import * as Types from '../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type GetInventoryItemsQueryVariables = Types.Exact<{
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
  last?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  before?: Types.InputMaybe<Types.Scalars['String']['input']>;
  where?: Types.InputMaybe<Types.InventoryItemDocumentFilterInput>;
  order?: Types.InputMaybe<Array<Types.InventoryItemDocumentSortInput> | Types.InventoryItemDocumentSortInput>;
}>;


export type GetInventoryItemsQuery = { __typename?: 'Query', inventoryItems?: { __typename?: 'InventoryItemsConnection', totalCount: number, nodes?: Array<{ __typename?: 'InventoryItemDocument', allocatedQuantity: number, availableQuantity: number, category: string, created: Types.TDateISO, genus: string, grade: number, group: string, heldQuantity: number, id: string, itemCode: string, itemId: string, itemName: string, itemType: Types.ItemType, lastTransactionDate: Types.TDateISO, lastTransactionType: string, locationId: string, locationName: string, onOrderQuantity: number, previousQuantity: number, quantity: number, readyDate?: string | null, readyWeek?: number | null, reasonCode: string, sku: string, tenantId: string, upc: string, updatedAt: Types.TDateISO, updatedBy: string, why: string, allocations: Array<{ __typename?: 'InventoryAllocationDocument', orderId: string, lineItemId: string, grade: number, quantity: number, allocatedBy: string }>, batches: Array<{ __typename?: 'InventoryBatch', code: string, sourceKind: Types.BatchSourceKind, ageDate?: string | null, plantDate?: string | null, plantStatus?: string | null, quantity: number }>, itemShippingUom?: { __typename?: 'ItemShippingUomData', code: string, eachesPerUnit?: number | null, label: string } | null, latestNote?: { __typename?: 'InventoryNoteDocument', noteId: string, submitDate: Types.TDateISO, submittedBy: string, text: string } | null, notes: Array<{ __typename?: 'InventoryNoteDocument', noteId: string, submitDate: Types.TDateISO, submittedBy: string, text: string }>, sourceJobContributions: Array<{ __typename?: 'InventorySourceJobContributionDocument', productionJobId: string, contributedQuantity: number, jobReadyWeekDate: string, jobReadyWeek: number }> }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export type GetInventoryItemAvailabilityQueryVariables = Types.Exact<{
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
  where?: Types.InputMaybe<Types.InventoryItemDocumentFilterInput>;
  order?: Types.InputMaybe<Array<Types.InventoryItemDocumentSortInput> | Types.InventoryItemDocumentSortInput>;
}>;


export type GetInventoryItemAvailabilityQuery = { __typename?: 'Query', inventoryItems?: { __typename?: 'InventoryItemsConnection', totalCount: number, nodes?: Array<{ __typename?: 'InventoryItemDocument', availableQuantity: number, itemId: string, locationId: string, locationName: string, readyDate?: string | null }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export type GetEngageStoreBatchesQueryVariables = Types.Exact<{
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
  where?: Types.InputMaybe<Types.InventoryItemDocumentFilterInput>;
  order?: Types.InputMaybe<Array<Types.InventoryItemDocumentSortInput> | Types.InventoryItemDocumentSortInput>;
}>;


export type GetEngageStoreBatchesQuery = { __typename?: 'Query', inventoryItems?: { __typename?: 'InventoryItemsConnection', totalCount: number, nodes?: Array<{ __typename?: 'InventoryItemDocument', id: string, itemId: string, locationId: string, grade: number, quantity: number, batches: Array<{ __typename?: 'InventoryBatch', code: string, sourceKind: Types.BatchSourceKind, ageDate?: string | null, plantDate?: string | null, plantStatus?: string | null, quantity: number }> }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export type ItemShippingUomFieldsFragment = { __typename?: 'ItemShippingUomData', code: string, eachesPerUnit?: number | null, label: string };

export type InventoryBatchFieldsFragment = { __typename?: 'InventoryBatch', code: string, sourceKind: Types.BatchSourceKind, ageDate?: string | null, plantDate?: string | null, plantStatus?: string | null, quantity: number };

export type InventoryNoteFieldsFragment = { __typename?: 'InventoryNoteDocument', noteId: string, submitDate: Types.TDateISO, submittedBy: string, text: string };

export type InventoryItemDetailsFragment = { __typename?: 'InventoryItemDocument', allocatedQuantity: number, availableQuantity: number, category: string, created: Types.TDateISO, genus: string, grade: number, group: string, heldQuantity: number, id: string, itemCode: string, itemId: string, itemName: string, itemType: Types.ItemType, lastTransactionDate: Types.TDateISO, lastTransactionType: string, locationId: string, locationName: string, onOrderQuantity: number, previousQuantity: number, quantity: number, readyDate?: string | null, readyWeek?: number | null, reasonCode: string, sku: string, tenantId: string, upc: string, updatedAt: Types.TDateISO, updatedBy: string, why: string, allocations: Array<{ __typename?: 'InventoryAllocationDocument', orderId: string, lineItemId: string, grade: number, quantity: number, allocatedBy: string }>, batches: Array<{ __typename?: 'InventoryBatch', code: string, sourceKind: Types.BatchSourceKind, ageDate?: string | null, plantDate?: string | null, plantStatus?: string | null, quantity: number }>, itemShippingUom?: { __typename?: 'ItemShippingUomData', code: string, eachesPerUnit?: number | null, label: string } | null, latestNote?: { __typename?: 'InventoryNoteDocument', noteId: string, submitDate: Types.TDateISO, submittedBy: string, text: string } | null, notes: Array<{ __typename?: 'InventoryNoteDocument', noteId: string, submitDate: Types.TDateISO, submittedBy: string, text: string }>, sourceJobContributions: Array<{ __typename?: 'InventorySourceJobContributionDocument', productionJobId: string, contributedQuantity: number, jobReadyWeekDate: string, jobReadyWeek: number }> };

export type InventoryItemStateFieldsFragment = { __typename?: 'InventoryItemStateData', availableQuantity: number, grade: number, id: string, itemId: string, itemName?: string | null, itemType: Types.ItemType, locationId: string, locationName?: string | null, previousQuantity: number, quantity: number, readyDate?: string | null, readyWeek?: number | null, sku: string, tenantId: string, upc?: string | null, updatedAt: Types.TDateISO, updatedBy: string, why: string, batches: Array<{ __typename?: 'InventoryBatch', code: string, sourceKind: Types.BatchSourceKind, ageDate?: string | null, plantDate?: string | null, plantStatus?: string | null, quantity: number }> };

export const InventoryBatchFieldsFragmentDoc = new TypedDocumentString(`
    fragment InventoryBatchFields on InventoryBatch {
  code
  sourceKind
  ageDate
  plantDate
  plantStatus
  quantity
}
    `, {"fragmentName":"InventoryBatchFields"});
export const ItemShippingUomFieldsFragmentDoc = new TypedDocumentString(`
    fragment ItemShippingUomFields on ItemShippingUomData {
  code
  eachesPerUnit
  label
}
    `, {"fragmentName":"ItemShippingUomFields"});
export const InventoryNoteFieldsFragmentDoc = new TypedDocumentString(`
    fragment InventoryNoteFields on InventoryNoteDocument {
  noteId
  submitDate
  submittedBy
  text
}
    `, {"fragmentName":"InventoryNoteFields"});
export const InventoryItemDetailsFragmentDoc = new TypedDocumentString(`
    fragment InventoryItemDetails on InventoryItemDocument {
  allocatedQuantity
  allocations {
    orderId
    lineItemId
    grade
    quantity
    allocatedBy
  }
  availableQuantity
  batches {
    ...InventoryBatchFields
  }
  category
  created
  genus
  grade
  group
  heldQuantity
  id
  itemCode
  itemId
  itemName
  itemShippingUom {
    ...ItemShippingUomFields
  }
  itemType
  lastTransactionDate
  lastTransactionType
  latestNote {
    ...InventoryNoteFields
  }
  locationId
  locationName
  notes {
    ...InventoryNoteFields
  }
  onOrderQuantity
  previousQuantity
  quantity
  readyDate
  readyWeek
  reasonCode
  sku
  sourceJobContributions {
    productionJobId
    contributedQuantity
    jobReadyWeekDate
    jobReadyWeek
  }
  tenantId
  upc
  updatedAt
  updatedBy
  why
}
    fragment ItemShippingUomFields on ItemShippingUomData {
  code
  eachesPerUnit
  label
}
fragment InventoryBatchFields on InventoryBatch {
  code
  sourceKind
  ageDate
  plantDate
  plantStatus
  quantity
}
fragment InventoryNoteFields on InventoryNoteDocument {
  noteId
  submitDate
  submittedBy
  text
}`, {"fragmentName":"InventoryItemDetails"});
export const InventoryItemStateFieldsFragmentDoc = new TypedDocumentString(`
    fragment InventoryItemStateFields on InventoryItemStateData {
  availableQuantity
  batches {
    ...InventoryBatchFields
  }
  grade
  id
  itemId
  itemName
  itemType
  locationId
  locationName
  previousQuantity
  quantity
  readyDate
  readyWeek
  sku
  tenantId
  upc
  updatedAt
  updatedBy
  why
}
    fragment InventoryBatchFields on InventoryBatch {
  code
  sourceKind
  ageDate
  plantDate
  plantStatus
  quantity
}`, {"fragmentName":"InventoryItemStateFields"});
export const GetInventoryItemsDocument = new TypedDocumentString(`
    query GetInventoryItems($first: Int, $after: String, $last: Int, $before: String, $where: InventoryItemDocumentFilterInput, $order: [InventoryItemDocumentSortInput!]) {
  inventoryItems(
    first: $first
    after: $after
    last: $last
    before: $before
    where: $where
    order: $order
  ) {
    nodes {
      ...InventoryItemDetails
    }
    pageInfo {
      ...PageInfo
    }
    totalCount
  }
}
    fragment ItemShippingUomFields on ItemShippingUomData {
  code
  eachesPerUnit
  label
}
fragment InventoryBatchFields on InventoryBatch {
  code
  sourceKind
  ageDate
  plantDate
  plantStatus
  quantity
}
fragment InventoryNoteFields on InventoryNoteDocument {
  noteId
  submitDate
  submittedBy
  text
}
fragment InventoryItemDetails on InventoryItemDocument {
  allocatedQuantity
  allocations {
    orderId
    lineItemId
    grade
    quantity
    allocatedBy
  }
  availableQuantity
  batches {
    ...InventoryBatchFields
  }
  category
  created
  genus
  grade
  group
  heldQuantity
  id
  itemCode
  itemId
  itemName
  itemShippingUom {
    ...ItemShippingUomFields
  }
  itemType
  lastTransactionDate
  lastTransactionType
  latestNote {
    ...InventoryNoteFields
  }
  locationId
  locationName
  notes {
    ...InventoryNoteFields
  }
  onOrderQuantity
  previousQuantity
  quantity
  readyDate
  readyWeek
  reasonCode
  sku
  sourceJobContributions {
    productionJobId
    contributedQuantity
    jobReadyWeekDate
    jobReadyWeek
  }
  tenantId
  upc
  updatedAt
  updatedBy
  why
}
fragment PageInfo on PageInfo {
  hasNextPage
  hasPreviousPage
  startCursor
  endCursor
}`);
export const GetInventoryItemAvailabilityDocument = new TypedDocumentString(`
    query GetInventoryItemAvailability($first: Int, $after: String, $where: InventoryItemDocumentFilterInput, $order: [InventoryItemDocumentSortInput!]) {
  inventoryItems(first: $first, after: $after, where: $where, order: $order) {
    nodes {
      availableQuantity
      itemId
      locationId
      locationName
      readyDate
    }
    pageInfo {
      ...PageInfo
    }
    totalCount
  }
}
    fragment PageInfo on PageInfo {
  hasNextPage
  hasPreviousPage
  startCursor
  endCursor
}`);
export const GetEngageStoreBatchesDocument = new TypedDocumentString(`
    query GetEngageStoreBatches($first: Int, $after: String, $where: InventoryItemDocumentFilterInput, $order: [InventoryItemDocumentSortInput!]) {
  inventoryItems(first: $first, after: $after, where: $where, order: $order) {
    nodes {
      id
      itemId
      locationId
      grade
      quantity
      batches {
        ...InventoryBatchFields
      }
    }
    pageInfo {
      ...PageInfo
    }
    totalCount
  }
}
    fragment InventoryBatchFields on InventoryBatch {
  code
  sourceKind
  ageDate
  plantDate
  plantStatus
  quantity
}
fragment PageInfo on PageInfo {
  hasNextPage
  hasPreviousPage
  startCursor
  endCursor
}`);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    GetInventoryItems: build.query<GetInventoryItemsQuery, GetInventoryItemsQueryVariables | void>({
      query: (variables) => ({ document: GetInventoryItemsDocument, variables })
    }),
    GetInventoryItemAvailability: build.query<GetInventoryItemAvailabilityQuery, GetInventoryItemAvailabilityQueryVariables | void>({
      query: (variables) => ({ document: GetInventoryItemAvailabilityDocument, variables })
    }),
    GetEngageStoreBatches: build.query<GetEngageStoreBatchesQuery, GetEngageStoreBatchesQueryVariables | void>({
      query: (variables) => ({ document: GetEngageStoreBatchesDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useGetInventoryItemsQuery, useLazyGetInventoryItemsQuery, useGetInventoryItemAvailabilityQuery, useLazyGetInventoryItemAvailabilityQuery, useGetEngageStoreBatchesQuery, useLazyGetEngageStoreBatchesQuery } = injectedRtkApi;
